import { createFileRoute } from '@tanstack/react-router';
import { CaptureLayout } from '@web/modules/capture/layout/capture-layout';

/** The capture area (spec 025): the areas as tabs on top, each screen under them. */
export const Route = createFileRoute('/_app/capture')({
  component: CaptureLayout,
});
